export interface OrderFinanceFilters {
  search?: string
  shopId?: string
  shopIds?: string[]
  status?: string
  createdFrom?: string
  createdTo?: string
  minimumAmount?: number
  maximumAmount?: number
}

export interface FilteredOrderFinanceSummary {
  orderCount: number
  excludedOrderCount: number
  cancelledCostOrderCount: number
  cancelledLogisticsCny?: string
  cancelledFeeOrderCount?: number
  defaultedOrderCount: number
  orderAmountCny: string
  platformFeeCny: string
  otherFeeCny: string
  lastMileDeliveryCny: string
  crossBorderShippingCny: string
  costCny: string
  netProfitCny: string
  profitRate: number | null
  computedAt: string
}

export function orderFinanceSummaryPath(filters: OrderFinanceFilters, refresh = false) {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === '' || (Array.isArray(value) && !value.length)) continue
    params.set(key, Array.isArray(value) ? [...value].sort().join(',') : String(value))
  }
  if (refresh) params.set('refresh', 'true')
  return `/orders/finance-summary${params.size ? `?${params}` : ''}`
}

/** Neither page number nor page size may change the full-filter totals cache. */
export function orderFinanceSummaryKey(tenantId: string | null | undefined, userId: string | undefined, filters: OrderFinanceFilters) {
  return ['orders', 'finance-summary', tenantId, userId, orderFinanceSummaryPath(filters)] as const
}
